export const SETTINGS_SUBSCRIPTIONS_API = '/api/dashboard/settings/subscriptions'
